import {
  API_BASE_URL,
  API_END_POINT,
  ENTITY_MANAGER_END_POINTS,
} from '../utils/environment'
import axiosInstance from '../utils/axiosInstance'
import {
  createProgramApiType,
  ProgramBulkUpdate,
  ProgramEnableRequest,
  programId,
  ProgramUpdateType,
  RequestParams,
} from '../types/programDetailsTypes'
import axios from 'axios'
import { SearchFilterType, TableFilterApiBody } from '../types'
import { FieldValues } from 'react-hook-form'
import { validateApiParams } from '../utils/functions'
interface propsTypeProgram {
  payload: {
    sort?: string
    searchDto: {
      fields: never[] | null
      search_criteria: {
        search_key: string
        search_value: string[]
        operator: string
      }[]
    }
    fieldsToInclude: string[]
    ColumnNames: string[]
  }
  fileType: string
  TenantId?: number | undefined
}
const getAllPrograms = async (payload: RequestParams) => {
  return await axiosInstance.get(
    `${API_END_POINT.CORE}programs?page=${payload.page - 1}&size=${
      payload.size
    }&sort=enabled,DESC&sort=${payload.sort}`
  )
}
const getAllTimeZones = async () => {
  return await axiosInstance.get(`${API_END_POINT.CORE}timezone`)
}
const getAllServices = async () => {
  return await axiosInstance.get(`${API_END_POINT.CORE}services`)
}
const getSubServices = async (service: string) => {
  const payload = {
    entity_id: '31',
    select: ['name', 'service'],
    page: 0,
    size: 25,
    related_entities: {
      service: {
        select: ['service_name'],
        filters: [
          {
            criteria: [
              {
                field_name: 'service_name',
                values: [service],
                operation: 'LIKE',
              },
            ],
          },
          {
            criteria: [
              {
                direction: 'ASC',
                field_name: 'record_status',
                operation: 'LIKE',
                values: [],
              },
            ],
          },
        ],
      },
    },
  }
  return await axiosInstance.post(
    `${API_END_POINT.ENTITY_MANAGER_V3}entity-data/get/cases_entity_search_view`,
    payload
  )
}
const getAllCaseSubType = async (programId: string, productId: string) => {
  return await axiosInstance.get(
    `${API_END_POINT.CORE}programs/${programId}/products/${productId}/services-subservices`
  )
}
const getAllServiceSubService = async () => {
  return await axiosInstance.get(`${API_END_POINT.CORE}services/subservices`)
}
const getAllTerritories = async () => {
  return await axiosInstance.get(`${API_END_POINT.CORE}territories`)
}
const createProgramApi = async (payload: createProgramApiType) => {
  return await axiosInstance.post(
    `${API_END_POINT.CORE}programs`,
    payload?.data
  )
}
const getAllUserProgram = async () => {
  return await axiosInstance.get(`${API_END_POINT.CORE}users`)
}
const getAllUsers = async () => {
  return await axiosInstance.get(`${API_END_POINT.CORE}users/all`)
}
const getAllProducts = async () => {
  return await axiosInstance.get(`${API_END_POINT.CORE}products`)
}
const updateAWSPresignedURLProgram = async (
  presignedUrl: string,
  selectedFile: File,
  selectedTenantId: number | undefined,
  tagging?: string | undefined,
  documentIdentifierMetaData?: string | undefined
) => {
  return await axios.put(presignedUrl, selectedFile, {
    headers: {
      'Content-Type': selectedFile.type,
      'x-tenantid': selectedTenantId,
      ...(tagging ? { 'x-amz-tagging': tagging } : {}),
      ...(documentIdentifierMetaData
        ? { 'x-amz-meta-DOCUMENT_IDENTIFIER': documentIdentifierMetaData }
        : {}),
    },
  })
}
const updatePresignedURLProgram = async (selectedFileName: string) => {
  validateApiParams(
    { selectedFileName },
    {
      endpoint: `${API_END_POINT.CORE}v1/files/generate-presigned-url/PUBLIC?fileName=${selectedFileName}`,
      method: 'PUT',
    }
  )
  return await axiosInstance.put(
    `${API_END_POINT.CORE}v1/files/generate-presigned-url/PUBLIC?fileName=${selectedFileName}`
  )
}
const getProgramById = async (payload: programId) => {
  return await axiosInstance.get(`${API_END_POINT.CORE}programs/${payload.id}`)
}
const updateProgramApi = async (payload: ProgramUpdateType) => {
  return await axiosInstance.put(
    `${API_END_POINT.CORE}programs/${payload?.id}`,
    payload
  )
}
const updateEnableProgramApi = async (payload: ProgramEnableRequest) => {
  console.log(payload)
  // return await axiosInstance.patch(
  //   `${API_END_POINT.CORE}client/programs/${payload?.str}?enable=true`
  // )
}
const updateDisableProgramApi = async (payload: ProgramEnableRequest) => {
  return await axiosInstance.patch(
    `${API_END_POINT.CORE}programs/${payload.programId}?enable=${payload.enabled}`
  )
}
const patchToggleUpdateBulkDisableProgramApi = async (
  payload: ProgramBulkUpdate
) => {
  return await axiosInstance.patch(
    `${API_END_POINT.CORE}programs/programs?enable=${payload.enabled}`,
    payload.programIds
  )
}
export const columnFilterProgramsAPI = async (payload: {
  page: number
  size: number
  filter: TableFilterApiBody
  sort?: string
}) => {
  return await axiosInstance.post(
    `${API_END_POINT.CORE}programs/filter/advance?sort=enabled,DESC`,
    payload?.filter,
    {
      params: {
        page: payload?.page - 1,
        size: payload?.size,
        sort: payload?.sort,
      },
    }
  )
}
const searchFilterProgramAPI = async (payload: SearchFilterType) => {
  return await axiosInstance.post(
    `${API_END_POINT.CORE}programs/filter/advance`,
    payload
  )
}
export const fetchDataForExportProgramAPI = async ({
  payload,
  fileType,
}: propsTypeProgram) => {
  return await axiosInstance.post(
    `${API_END_POINT.CORE}export/program/advance/${fileType}/?sort=enabled,DESC&sort=${payload?.sort}`,
    {
      ...payload,
    }
  )
}
const programSearchURL = `${API_END_POINT.CORE}programs/filter-data/`

const addEntitiesData = async (
  entityName: string,
  data: FieldValues,
  embedded: string[] = []
) => {
  return await axiosInstance.post(
    `${API_END_POINT.ENTITY_MANAGER_V3}${ENTITY_MANAGER_END_POINTS.ENTITY_DATA}/${entityName}`,
    {
      meta_data: {
        entity_name: entityName,
        embedded: embedded,
      },
      data: data,
    }
  )
}
const editEntitiesData = async (
  entityName: string,
  data: FieldValues,
  dataId: number | string,
  embedded: string[] = []
) => {
  const endpoint = `${API_END_POINT.ENTITY_MANAGER_V3}${ENTITY_MANAGER_END_POINTS.ENTITY_DATA}/${entityName}/${dataId}`
  validateApiParams(
    { entityName, dataId },
    {
      endpoint,
      method: 'PUT',
    }
  )
  return await axiosInstance.put(endpoint, {
    meta_data: {
      entity_name: entityName,
      embedded,
    },
    data: data,
  })
}
const getAllEmails = async () => {
  return await axiosInstance.get(`${API_BASE_URL}mail-consumer/v1/emails`)
}

export {
  getAllUserProgram,
  createProgramApi,
  getProgramById,
  updateProgramApi,
  updateEnableProgramApi,
  patchToggleUpdateBulkDisableProgramApi,
  updateDisableProgramApi,
  getAllPrograms,
  getAllTimeZones,
  getAllServices,
  getAllTerritories,
  getAllProducts,
  updateAWSPresignedURLProgram,
  updatePresignedURLProgram,
  searchFilterProgramAPI,
  getAllUsers,
  programSearchURL,
  addEntitiesData,
  editEntitiesData,
  getAllCaseSubType,
  getAllServiceSubService,
  getAllEmails,
  getSubServices,
}
